import WaterMapContainer from "./WaterMapContainer";

export default WaterMapContainer;